import { render } from "./xtx-bread-item.vue?vue&type=template&id=f9e24174"
import script from "./xtx-bread-item.vue?vue&type=script&lang=js"
export * from "./xtx-bread-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__